<template>
    <section id="landing-page">
        <div class="hero">
            <div class="hero-image-wrapper">
                <img
                    src="/images/svg/tripwards-logo.svg"
                    alt="Tripwards Hero Logo"
                />
                <span class="logo-subtitle">Towards your next trip</span>
            </div>
        </div>

        <div class="features">
            <div ref="featuresContainer" class="features-container">
                <svg
                    viewBox="0 0 146.10786 70.920769"
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="none"
                >
                    <g transform="translate(-20.605374,-466.46731)">
                        <path
                            ref="path"
                            d="m 20.995964,472.14673 c 8.938,-3.40129 18.519511,-5.10268 28.082101,-4.98652 9.673643,0.1175 19.296343,2.08753 28.344552,5.51143 2.632774,0.99626 5.287351,2.15963 7.28424,4.14368 0.998444,0.99203 1.814515,2.18392 2.274234,3.5142 0.459719,1.33029 0.550515,2.80242 0.152158,4.15235 -0.374622,1.2695 -1.159489,2.38377 -2.065599,3.34862 -0.90611,0.96485 -1.939163,1.79998 -2.920942,2.68772 -1.045877,0.9457 -2.042726,1.96191 -2.815254,3.14148 -0.772529,1.17958 -1.314931,2.53632 -1.383938,3.94467 -0.06294,1.28447 0.272854,2.57541 0.886238,3.70571 0.613385,1.1303 1.497544,2.103 2.517963,2.88566 2.040838,1.56533 4.571148,2.35521 7.093781,2.85679 11.630782,2.31257 24.138862,-1.16909 33.331092,-8.66082 5.32875,-4.34296 9.74641,-10.02603 16.00942,-12.86004 5.04234,-2.28166 11.03331,-2.42843 16.13776,-0.28932 5.10445,2.1391 9.2263,6.55998 10.89455,11.83711 1.0388,3.28601 1.14688,6.80805 0.78734,10.23554 -0.47882,4.56463 -1.80965,9.11144 -4.41128,12.89252 -2.60164,3.78108 -6.56112,6.73836 -11.07324,7.57853 -3.31429,0.61713 -6.75963,0.0857 -9.95597,-0.98609 -3.19634,-1.0718 -6.18673,-2.66794 -9.16973,-4.23864 -2.98299,-1.5707 -5.99582,-3.13175 -9.21722,-4.12569 -3.2214,-0.99394 -6.69426,-1.39982 -9.97471,-0.62266 -3.52342,0.83472 -6.61542,2.98002 -9.21024,5.50553 -2.594815,2.5255 -4.764146,5.44671 -7.085588,8.22559 -2.321443,2.77888 -4.847102,5.46023 -7.949892,7.32677 -3.10279,1.86653 -6.870354,2.85599 -10.397621,2.03767 -2.668239,-0.61903 -5.030116,-2.22579 -6.933665,-4.19535 -1.90355,-1.96957 -3.390455,-4.29846 -4.796819,-6.64896 -1.406364,-2.35049 -2.751663,-4.74875 -4.420932,-6.92044 -1.66927,-2.17169 -3.695181,-4.1295 -6.156798,-5.3308 -2.19284,-1.07014 -4.67837,-1.50297 -7.11268,-1.33602 -2.43431,0.16695 -4.81524,0.92422 -6.94927,2.10729 -4.268059,2.36614 -7.464777,6.36841 -9.55851,10.7765 -2.430567,5.11725 -3.486128,10.95178 -2.542951,16.53786 0.943176,5.58608 3.968699,10.87688 8.579293,14.16873 4.167817,2.97572 9.416978,4.21049 14.536214,4.0725 5.119236,-0.138 10.131869,-1.57578 14.858135,-3.54759 5.236452,-2.18466 10.180583,-5.0268 15.432679,-7.17357 5.252095,-2.14678 10.968552,-3.59676 16.586166,-2.79953 5.939959,0.84298 11.217409,4.09326 16.796769,6.29879 8.11377,3.20739 17.00094,4.23927 24.93271,7.8735 5.54953,2.54272 10.52048,6.33871 14.43473,11.02287"
                            transform="matrix(1.001342,0,0,0.64464731,-0.1256223,165.84806)"
                            fill="none"
                            stroke="#fff"
                            :stroke-width="
                                ['sm', 'xs'].includes(screenSize) ? 1 : 0.7
                            "
                            opacity="0.8"
                        />
                    </g>
                </svg>
                <div ref="goText" class="go-text">Go!</div>
                <div ref="plan" class="feature feature-plan">
                    <div class="feature-inner-wrapper">
                        <span class="material-symbols-outlined">
                            location_on
                        </span>
                        <span class="feature-title"
                            >Get trip<br />inspirations</span
                        >
                    </div>
                </div>
                <div ref="customize" class="feature feature-customize">
                    <div class="feature-inner-wrapper">
                        <span class="material-symbols-outlined"> edit </span>
                        <span class="feature-title"
                            >Write down your<br />experience</span
                        >
                    </div>
                </div>
                <div ref="complete" class="feature feature-complete">
                    <div class="feature-inner-wrapper">
                        <span class="material-symbols-outlined"> check </span>
                        <span class="feature-title"
                            >Keep track of<br />all your travels</span
                        >
                    </div>
                </div>
            </div>
        </div>
        <div class="framed-content">
            <p>
                Your travel memories shouldn't be scattered across notes and
                spreadsheets.
            </p>
            <p>Tripwards brings it all together.</p>
        </div>
        <div class="start-button-wrapper red-button">
            <LinkBttn class="button" route="/login"> Start exploring </LinkBttn>
        </div>
        <div class="max-width-container">
            <div class="screenshots-wrapper">
                <img src="/images/landing/screen1.png" class="screen1" />
                <img src="/images/landing/screen2.png" class="screen2" />
                <img src="/images/landing/screen3.png" class="screen3" />
                <img src="/images/landing/screen4.png" class="screen4" />
                <img src="/images/landing/screen5.png" class="screen5" />
            </div>
        </div>
        <div ref="keyPointsContainer" class="key-points-framed-content">
            <div ref="keyPoints" class="key-points">
                <p>Tripwards is your companion on every step of the way:</p>
                <ul>
                    <li>
                        <span class="text-wrapper"
                            ><span class="material-symbols-outlined">check</span
                            >Get tailored travel ideas</span
                        >
                    </li>
                    <li>
                        <span class="text-wrapper"
                            ><span class="material-symbols-outlined">check</span
                            >Create a variety of bucketlists</span
                        >
                    </li>
                    <li>
                        <span class="text-wrapper"
                            ><span class="material-symbols-outlined">check</span
                            >Log your adventures</span
                        >
                    </li>
                    <li>
                        <span class="text-wrapper"
                            ><span class="material-symbols-outlined">check</span
                            >See your travel stats</span
                        >
                    </li>
                    <li>
                        <span class="text-wrapper"
                            ><span class="material-symbols-outlined">check</span
                            >Share trips and inspirations with companions</span
                        >
                    </li>
                </ul>
                <p ref="andMuchMore" class="and-much-more">And much more!</p>
            </div>
        </div>
        <div class="max-width-container">
            <div
                class="intro-video-wrapper"
                :class="{ unplayed: !isVideoPlayed }"
                @click="onVideoClick"
            >
                <video
                    v-if="isVideoPlayed"
                    ref="promoVideo"
                    width="768"
                    height="432"
                    controls
                    autoplay
                >
                    <source :src="promoVideoUrl" type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
                <div v-else class="still-container">
                    <img
                        src="/images/landing/video-frame.png"
                        alt="Promo video still"
                    />
                </div>
            </div>
        </div>
        <div class="cta-wrapper">
            <div class="cta-wrapper-inner">
                <div class="cta-content-wrapper">
                    <p class="action-call-title first-part">
                        Build your personal travel history<br />and watch your
                        world map fill up over time.
                    </p>
                    <div class="start-button-wrapper">
                        <LinkBttn class="button" route="/login">
                            Start exploring
                        </LinkBttn>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            timeouts: [],
            isVideoPlayed: false,
            promoVideoUrl: window.tripper.promoVideoUrl,
            resizeObserver: null,
            containerWidth: 0,
            screenSize: null,
            screenshotsHeight: null,
        };
    },
    mounted() {
        const path = this.$refs.path;
        const length = path.getTotalLength();

        // Start hidden
        path.style.strokeDasharray = length;
        path.style.strokeDashoffset = length;

        window.addEventListener("scroll", this.animate);

        const element = document.body;

        this.resizeObserver = new ResizeObserver((entries) => {
            for (const entry of entries) {
                const { width } = entry.contentRect;

                this.onWidthChange(width);
            }
        });

        this.resizeObserver.observe(element);
    },
    beforeUnmount() {
        this.timeouts = [];
        this.resizeObserver.disconnect();
        window.removeEventListener("scroll", this.animate);
    },
    methods: {
        animate() {
            window.removeEventListener("scroll", this.animate);

            const path = this.$refs.path;
            const length = path.getTotalLength();
            const multiplier = this.screenSize === "xs" ? 0.6 : 1;

            // Start hidden
            path.style.strokeDasharray = length;
            path.style.strokeDashoffset = length;
            path.style.transition = "none";

            // Force initial state
            void path.offsetWidth;

            this.timeouts.push(
                setTimeout(() => {
                    path.style.transition =
                        "stroke-dashoffset " + 3 * multiplier + "s linear";
                    path.style.strokeDashoffset = length / 2;
                }, 500 * multiplier)
            );

            this.$refs.plan.style.display = "flex";

            this.timeouts.push(
                setTimeout(() => {
                    this.$refs.goText.style.display = "block";
                    this.$refs.goText.classList.add("text-ready");
                }, 2000 * multiplier)
            );

            this.timeouts.push(
                setTimeout(() => {
                    this.$refs.customize.style.display = "flex";
                }, 3500 * multiplier)
            );

            // Pause for 1 second, then finish
            this.timeouts.push(
                setTimeout(() => {
                    path.style.transition =
                        "stroke-dashoffset " + 3 * multiplier + "s linear";
                    path.style.strokeDashoffset = 0;
                }, 4000 * multiplier)
            );

            this.timeouts.push(
                setTimeout(() => {
                    this.$refs.complete.style.display = "flex";
                }, 7000 * multiplier)
            );
        },
        onWidthChange(bodyWidth) {
            this.$refs.featuresContainer.style.width = bodyWidth * 0.8 + "px";

            const x = bodyWidth;

            switch (true) {
                case x >= 1201:
                    this.screenSize = "xl";
                    break;
                case x > 992:
                    this.screenSize = "lg";
                    break;
                case x > 768:
                    this.screenSize = "md";
                    break;
                case x > 480:
                    this.screenSize = "sm";
                    break;
                default:
                    this.screenSize = "xs";
            }

            const keyPointsHeight =
                this.$refs.keyPoints.getBoundingClientRect().height;
            const keyPointsContainer = this.$refs.keyPointsContainer;
            const newHeight = Math.round(keyPointsHeight + 120);

            keyPointsContainer.style.height = newHeight + "px";
            keyPointsContainer.style.maskSize = "100% " + newHeight + "px";
        },
        onVideoClick() {
            this.isVideoPlayed = true;

            const video = this.$refs.promoVideo;

            if (!video) {
                return;
            }

            video.play().catch(() => {
                this.isVideoPlayed = false;
            });
        },
    },
};
</script>
